// extracted by mini-css-extract-plugin
module.exports = {"baseWrapper":"EmptyBase_baseWrapper__3asEd","emptyBaseWrapper":"EmptyBase_emptyBaseWrapper___rznM"};